import { render, staticRenderFns } from "./ReportImageCarousel.vue?vue&type=template&id=4a74908d&scoped=true"
import script from "./ReportImageCarousel.vue?vue&type=script&lang=js"
export * from "./ReportImageCarousel.vue?vue&type=script&lang=js"
import style0 from "./ReportImageCarousel.vue?vue&type=style&index=0&id=4a74908d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a74908d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a74908d')) {
      api.createRecord('4a74908d', component.options)
    } else {
      api.reload('4a74908d', component.options)
    }
    module.hot.accept("./ReportImageCarousel.vue?vue&type=template&id=4a74908d&scoped=true", function () {
      api.rerender('4a74908d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/analytics/components/modules/ReportImageCarousel.vue"
export default component.exports